import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-play-circle-line text-sm"></i>
            热门视频
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            吃瓜现场
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            最火爆的爆料视频，直击娱乐圈第一现场，每一帧都是猛料
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.coverImage}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 backdrop-blur-sm group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 shadow-lg">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  {item.hot && (
                    <span className="bg-primary-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">HOT</span>
                  )}
                  <span className="bg-black/50 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-md">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-foreground-950 text-sm font-semibold leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-foreground-500 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}